import { useState } from "react";
import { BookOpen } from "lucide-react";
import { fileUrl } from "../lib/api";

export const PALETTES = [
  ["#8C3A27", "#B85C3E"], ["#2D5A4C", "#4E8B78"], ["#3B4C7A", "#6C7FB8"],
  ["#7A3B5E", "#B36088"], ["#6B5B2E", "#A18A4A"], ["#2E5A6B", "#4E8AA0"],
  ["#5A3B7A", "#8A63B8"], ["#7A4A2E", "#B87C4E"],
];

function hashIndex(str = "") {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h % PALETTES.length;
}

export function paletteFor(book) {
  if (book && Number.isInteger(book.cover_color) && book.cover_color >= 0 && book.cover_color < PALETTES.length) {
    return PALETTES[book.cover_color];
  }
  return PALETTES[hashIndex((book?.title || "") + (book?.author || ""))];
}

export default function BookCover({ book, className = "" }) {
  const url = fileUrl(book);
  const [broken, setBroken] = useState(false);
  const showImg = url && !broken;

  if (showImg) {
    return (
      <img
        src={url}
        alt={book?.title || ""}
        loading="lazy"
        onError={() => setBroken(true)}
        className={`w-full h-full object-cover ${className}`}
      />
    );
  }

  const [c1, c2] = paletteFor(book);
  return (
    <div
      data-testid="cover-fallback"
      className={`w-full h-full flex flex-col justify-between p-[8%] text-white relative overflow-hidden ${className}`}
      style={{ background: `linear-gradient(150deg, ${c1} 0%, ${c2} 100%)`, containerType: "inline-size" }}
    >
      <BookOpen className="w-[16%] h-auto opacity-80" style={{ minWidth: 16 }} />
      <div>
        <p className="font-serif font-semibold leading-tight break-words" style={{ fontSize: "clamp(0.8rem, 4cqw, 1.15rem)" }}>
          {book?.title}
        </p>
        {book?.author && <p className="opacity-80 mt-1 break-words" style={{ fontSize: "clamp(0.65rem, 3cqw, 0.85rem)" }}>{book.author}</p>}
      </div>
      <span className="absolute inset-y-0 left-[6%] w-px bg-white/25" />
    </div>
  );
}
